function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context('.', true, /\.(svg|eot|woff2?|ttf)$/));
